import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';

import { SettingBar } from 'handimap-react-lib/containers/SettingBar';

export const LayersBarSection = () => {

  const { t } = useTranslation();

  const [expanded, setExpanded] = useState(false); 

  const handleClickExpand = () => {
    setExpanded(!expanded);
  };

  const styles = {
    container : {
      display: 'flex',
      width: '70%',
      height: expanded ? 'max-content' : 60,
      borderRadius: '.5em',
      backgroundColor: '#FFFFFF',
      paddingX: '1em',
      paddingBottom: '.3em',
      alignItems: expanded ? 'center' : 'flex-start'
    },
    layerContainer: {
      display: 'flex',
      flexGrow: 1,
      height: expanded ? 'max-content' : 50,
      paddingY: '.3em',
      overflowY: 'hidden',
      alignItems: 'flex-start'
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      alignItems: 'center',
      paddingY: '.3em',
    },
    buttonStyle: {
      display: 'flex',
      width: 'max-content',
      fontSize: '1em',
      alignVertical: 'center',
      textTransform: 'none',
      '&:hover': {
        textDecoration: 'underline'
      },
      color: '#000000',
      fontWeight: 700
    }
  };
  return (
    <Box sx={styles.container}>
      <Box sx={styles.layerContainer}>
        <SettingBar />
      </Box>
      <Box sx={styles.buttonContainer}>
        <Button 
          id='layer_settings_open'
          aria-label={expanded ? t('common.aria_button_layer_less') : t('common.aria_button_layer_all')}
          sx={styles.buttonStyle} 
          variant='text' 
          endIcon={ expanded ? <ArrowDropUp /> : <ArrowDropDown />}
          onClick={handleClickExpand}
        >
          { expanded ? t('common.layer_less') : t('common.layer_all')}
        </Button>
      </Box>
    </Box>
  );
};